export default __webpack_public_path__ + "static/media/jrc_logo_icon.a72658a1.ai";